import { useBuildVersionPoller } from './use-build-version-poller'
import { useChunkLoadErrorReload } from './use-chunk-load-error-reload'
import { useForcedReload } from './use-forced-reload'
import { useSafeReload } from './use-safe-reload'

/**
 * Single mounting point for stale-client detection + reload: build-id polling (Tier 0),
 * silent reload at safe moments (Tier 1), forced reload via the `min_supported_web_version`
 * PostHog flag (Tier 3), and reload-on-chunk-load-error. Mount once, globally — see
 * `GlobalListeners.jsx`. There is no Tier 2 (passive banner) yet — see EL-13298.
 */
export const useStaleClientReload = () => {
  useBuildVersionPoller()
  useSafeReload()
  useForcedReload()
  useChunkLoadErrorReload()
}
